import { render } from "./Game.vue?vue&type=template&id=de7c78a4&scoped=true"
import script from "./Game.vue?vue&type=script&lang=js"
export * from "./Game.vue?vue&type=script&lang=js"

import "./Game.vue?vue&type=style&index=0&id=de7c78a4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-de7c78a4"

export default script